






import { Component, Vue, Prop } from 'nuxt-property-decorator';
import { notificationTypes } from '@/components/global/HeaderMenu/HeaderMenuNotifications/constants';
import { iconTypes } from './constants';

type NotificationType = typeof notificationTypes[keyof typeof notificationTypes];
type IconType = typeof iconTypes[keyof typeof iconTypes];

const iconsMap = new Map<NotificationType, IconType | null>([
  [notificationTypes.REACTION_TO_COMMENT, null],
  [notificationTypes.REACTION_TO_POST, null],
  [notificationTypes.COMMENT, iconTypes.COMMENT],
  [notificationTypes.REPLY_TO_COMMENT, iconTypes.REPLY],
  [notificationTypes.MENTION_IN_COMMENT, iconTypes.MENTION],
  [notificationTypes.MENTION_IN_POST, iconTypes.MENTION],
  [notificationTypes.OFFICIAL_POST, iconTypes.OFFICIAL_POST],
  [notificationTypes.MOBILE_APP_POST, iconTypes.OFFICIAL_POST],
  [notificationTypes.TESTIMONIAL, iconTypes.OFFICIAL_POST],
  [notificationTypes.CONTACTS_REMINDER, iconTypes.CONTACTS_REMINDER],
]);

@Component<HeaderMenuNotificationsCardGridAvatarTypeIcon>({})
export default class HeaderMenuNotificationsCardGridAvatarTypeIcon extends Vue {
  @Prop({ required: true }) type!: NotificationType;

  get rootClass(): string[] {
    return ['header-menu-notifications-card-type-icon', `header-menu-notifications-card-type-icon--${this.iconType}`];
  }

  get icon(): string {
    return require(`./images/${this.iconType}-icon.vue.svg`);
  }

  get iconType(): string | null {
    const value = iconsMap.get(this.type);
    if (value === undefined) {
      return iconTypes.RATING;
    }

    return value;
  }
}
